export default {
  props: {
    required: {
      type: Boolean
    },
    name: {
      type: String
    }
  }
};
